import React from 'react';
import Styled from 'styled';
import { useQuery } from '@apollo/client/react/hooks';
import { RouteComponentProps } from 'react-router';

import SettingsProfile from './profile/settings-profile';
import SettingsAccount from './account/settings-account';
import defaultStyles from './settings-profile-and-account.scss';
import query, {
    SettingsProfileAndAccountQuery,
    SettingsProfileAndAccountQueryVariables,
} from './settings-profile-and-account.graphql';

interface Props extends RouteComponentProps<{ username: string }> {
    styles: typeof defaultStyles;
}

const ProfileAndAccountSettings: React.FC<Props> = props => {
    const {
        styles,
        match: {
            params: { username },
        },
    } = props;

    const { data, refetch } = useQuery<SettingsProfileAndAccountQuery, SettingsProfileAndAccountQueryVariables>(query, {
        variables: { username: username },
    });

    if (
        !data ||
        !data.users ||
        !data.users.edges ||
        data.users.edges.length !== 1 ||
        !data.users.edges[0]!.node ||
        !data.users.edges[0]?.node.profile
    ) {
        return null;
    }

    const user = data.users.edges[0]!.node;

    return (
        <div className={styles.wrapper}>
            <SettingsProfile {...user} />
            <div className={styles.divider} />
            <SettingsAccount {...user} refetch={refetch} />
        </div>
    );
};

export default Styled(defaultStyles)(ProfileAndAccountSettings);
